var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"related-articles__container"},_vm._l((_vm.articles),function(article){return _c('related-article',{key:article.id,staticClass:"related-article--static",attrs:{"article":article,"preferred-img-crop":"landscape","desktop-img-size":422}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }